import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService } from '../../services/email.service';

@Component({
  selector: 's18-push-notification-dialog',
  templateUrl: './push-notification-dialog.component.html',
  styleUrls: ['./push-notification-dialog.component.scss']
})
export class PushNotificationDialogComponent implements OnInit {
  sender : string;
  recipientList: string;
  message: string;
  sending: boolean = false;

  constructor(
    private pushService : MessageService,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<PushNotificationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { 
    this.sender = data.sender;
    this.recipientList = data.recipients;
  }

  ngOnInit() {
  }

  send(){
    this.sending = true;
    this.pushService.sendPushNotifications(this.recipientList, this.sender, this.message)
      .subscribe( resp => {
        this.sending = false;
        this.dialogRef.close(true);
      } );
  }

}
